import { TimeFormatOptions } from '@griply/types';
import { format } from 'date-fns';

export type GetEventTimeTextOptions = {
  allDay: boolean;
  isStart: boolean;
  isEnd: boolean;
  start: Date | null;
  timeFormat: TimeFormatOptions;
};

// Derives the time label shown on a calendar event card from FullCalendar's
// per-segment render args. Single-day timed events keep their full start–end
// range; multi-day timed events show only the start time on their first day and
// nothing on the following days (the cross-midnight "10:00 - 00:00" / "00:00 -
// 17:00" segments are noise). All-day events carry no time text.
export const getEventTimeText = (
  timeText: string,
  { allDay, isStart, isEnd, start, timeFormat }: GetEventTimeTextOptions,
): string => {
  if (allDay) {
    return timeText;
  }

  if (isStart && isEnd) {
    return timeText;
  }

  if (isStart) {
    return start ? format(start, timeFormat) : timeText;
  }

  return '';
};
